// extracted by mini-css-extract-plugin
export default {"icon_button":"Button_icon_button__zTztQ","save_button":"Button_save_button__cx3Fz"};